module.exports = __webpack_public_path__ + "img/dora.bb0801c3.svg";